import { c as _c } from "react/compiler-runtime";
import { type MediaOverlayContentProps } from '@/app/lcv/components/sections/spartan/shared/media-overlay/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const MediaOverlayContent = t0 => {
  const $ = _c(13);
  const {
    className: t1,
    logo,
    title,
    description,
    descriptionClassName,
    testId: t2
  } = t0;
  const className = t1 === undefined ? "space-y-6" : t1;
  const testId = t2 === undefined ? "media-overlay-content" : t2;
  let t3;
  if ($[0] !== testId) {
    t3 = createDataAttributes({
      test: testId
    });
    $[0] = testId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== title) {
    t4 = !!title && <h2 className="sr-only" {...createDataAttributes({
      test: "title"
    })}>{title}</h2>;
    $[2] = title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== description || $[5] !== descriptionClassName) {
    t5 = !!description && <div className={cn("text-body-1 where-span:text-inline-wrap text-center text-white", descriptionClassName)} dangerouslySetInnerHTML={{
      __html: description
    }} {...createDataAttributes({
      test: "description"
    })} />;
    $[4] = description;
    $[5] = descriptionClassName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== className || $[8] !== logo || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={className} {...t3}>{logo}{t4}{t5}</div>;
    $[7] = className;
    $[8] = logo;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};